<template>
  <section class="client-listing-area h-100">
    <div class="client-listing-head-fluid">
      <div class="container">
        <div class="client-listing-head"></div>
        <!-- ends client-listing-head -->
        <h2>検索条件保存一覧</h2>            
      </div>
    </div>
    <!-- ends client-listing-head-fluid -->
    <div class="client-listing-detail-fluid">
      <div class="container">
        <div class="client-listing-detail">
          <div class="table-responsive">

            <span style="color:red;">注意：1つの検索条件のみ初期検索条件に設定できます</span>
            <table class="table" v-show="!loading">
              <thead>
                <tr>
                  <th>検索条件名</th>
                  <th class="text-center">初期検索条件</th>
                  <th class="text-center">検索条件の反映</th>
                  <th class="text-center">検索条件の編集</th>
                  <th class="text-center">削除</th>
                </tr>
              </thead>
              <tbody>
                <TemplateRow
                  v-for="template in userTemplate"
                  v-bind:key="template.id+template.is_default"
                  :templateData="template"
                />
                <tr v-if="!userTemplate.length">
                  <td colspan="100%" class="text-center">テンプレートが見つかりません。</td>
                </tr>
              </tbody>
            </table>
            <Loader v-show="loading" />
          </div>
        </div>
        <!-- ends client-listing-detail -->
      </div>
    </div>
    <!-- ends client-listing-detail-fluid -->
  </section>
</template>

<script>
import Loader from "@/components/utils/Loader.vue";
import TemplateRow from "@/views/TemplateRow.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SearchTemplates",
  components: { TemplateRow, Loader },
  data() {
    return {
      loading: false,
      page: 1
    };
  },
  computed: {
    ...mapGetters({
      userTemplate: "getCurrentUserSearchTemplate",
      isReviewer: "isCreateReviewUser"
    })
  },
  async mounted() {
    await this.loadCurrentUser();
    if(!this.isReviewer){
      this.$router.push({ path: '/applicant' });
    }
    this.loadCurrentUserSearchTemplate();
  },
  methods: {
    ...mapActions({
      loadCurrentUserSearchTemplate: "loadCurrentUserSearchTemplate",
      loadCurrentUser: "loadCurrentUser"
    })
  },
};
</script>

<style>
</style>